/* eslint-disable no-unused-vars */
import { useForm, Controller } from 'react-hook-form';
import { CustomInput, Buttons } from 'components';
import * as S from './PublisherPayments.styled';

function trimData(data) {
  let trimmedData = {};

  Object.keys(data).forEach((key) => {
    if (typeof data[key] === 'string') {
      trimmedData[key] = data[key].trim();
    } else {
      trimmedData[key] = data[key];
    }
  });

  return trimmedData;
}

function removeSpace(fieldName, value) {
  console.log('value', value);
  if (fieldName === 'bankIbanNumber' || fieldName === 'bankSwiftCode')
    return value?.replaceAll(' ', '') || '';
  return value?.replaceAll('  ', ' ') || '';
}

const formRowStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 240px',
  marginBottom: '16px',
};

export const WireForm = ({
  wireFormFields,
  defaultData = {},
  onSetIsWireOpen,
  onHandleSavePayments,
  isButtonDisabled,
}) => {
  const {
    handleSubmit,
    control,
    trigger,
    clearErrors,
    formState: { isValid, isDirty, isSubmitting },
  } = useForm({
    mode: 'onSubmit',
    shouldFocusError: false,
    defaultValues: defaultData,
  });

  console.log('isDirty', isDirty);

  function onSubmit(data) {
    onHandleSavePayments(trimData(data), 1);
  }

  return (
    <S.StyledForm onSubmit={handleSubmit(onSubmit)}>
      {wireFormFields.map((item) => (
        <div key={item.id} style={{ position: 'relative' }}>
          <Controller
            name={item.id}
            control={control}
            rules={{
              required: item.required ? 'Field is required' : false,
              pattern: item.pattern || '',
              maxLength:
                item.id === 'bankIbanNumber'
                  ? {
                      value: 34,
                      message: 'The IBAN you entered is too long (up to 34 characters)',
                    }
                  : undefined,
            }}
            render={(props) => {
              const { field, fieldState } = props;
              const { name, value, onChange } = field;

              return (
                <CustomInput
                  multiline={item.tag === 'textarea'}
                  minRows={item.tag === 'textarea' ? 3 : 1}
                  type={item.type || 'text'}
                  name={name}
                  id={name}
                  onFocus={() => clearErrors(item.id)}
                  onBlur={() => trigger(item.id)}
                  onChange={(e) => onChange(removeSpace(item.id, e.target.value))}
                  error={fieldState.invalid}
                  errorText={fieldState.error?.message}
                  value={value || ''}
                  topLabel={item.title}
                  containerStyle={formRowStyles}
                  inputStyle={{ fontSize: '14px' }}
                />
              );
            }}
          />
          {item.hint ? <S.HintText>{item.hint}</S.HintText> : null}
        </div>
      ))}
      <S.ButtonsWrap style={{ width: '240px', marginLeft: 'auto' }}>
        <Buttons.SecondaryNormal
          id='canсel_wire'
          type='reset'
          onClick={() => onSetIsWireOpen(false)}
        >
          Canсel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='save_wire'
          type='submit'
          isDisabled={!isDirty || isButtonDisabled || !isValid || isSubmitting}
        >
          Save
        </Buttons.PrimaryNormal>
      </S.ButtonsWrap>
    </S.StyledForm>
  );
};
